import { render, staticRenderFns } from "./DepartmentPermissionRow.vue?vue&type=template&id=1864328e&scoped=true"
import script from "./DepartmentPermissionRow.vue?vue&type=script&lang=js"
export * from "./DepartmentPermissionRow.vue?vue&type=script&lang=js"
import style0 from "./DepartmentPermissionRow.vue?vue&type=style&index=0&id=1864328e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1864328e",
  null
  
)

export default component.exports